/**
 * Archivo de constantes globales para roles del sistema.
 *
 * Define los identificadores numéricos utilizados para validar permisos,
 * accesos a rutas y funcionalidades según el rol del usuario autenticado.
 *
 * Fecha: 19/06/2026
 * Autor: Zimatech - Ponce Federico
 */

/**
 * Rol Administrador.
 * Usuario con acceso completo al sistema y configuración general.
 */
export const ADMINISTRADOR = 1;

/**
 * Rol Director.
 * Usuario con permisos de supervisión, consulta y control de gestión.
 */
export const DIRECTOR = 2;

/**
 * Rol General.
 * Usuario con acceso estándar a las funcionalidades generales del sistema.
*/
export const GENERAL = 3;

/**
 * Rol Transferencia.
 * Usuario asociado a operaciones o gestiones del área de transferencia.
*/
export const TRANSFERENCIA = 4;

/**
 * Rol Administración.
 * Usuario asociado a tareas administrativas y gestión operativa.
*/
export const ADMINISTRACION = 5;